import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"width":"200px"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "每当白日依山尽，夕阳余辉便透过朵朵云层，像万道金光，如霞光万丈，把天空白云染得红彤彤，把大地山河映得金灿灿，仿佛整个世界在那一瞬间都变得金碧辉煌，热情奔放起来", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "每当白日依山尽，夕阳余辉便透过朵朵云层，像万道金光，如霞光万丈，把天空白云染得红彤彤，把大地山河映得金灿灿，仿佛整个世界在那一瞬间都变得金碧辉煌，热情奔放起来", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "left", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "right", -1)

import {} from 'vue'

// interface App {
//   add: () => void
// }
// const app = {
//   add: Function
// }

// function exec(app: Function) {
  
// }

// const add = (app: App) => {
//   console.log('hello')
// }

// exec(app => {
//   app.
// })

export default /*#__PURE__*/_defineComponent({
  __name: 'test',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_u_fold = _resolveComponent("u-fold")!
  const _component_u_divider = _resolveComponent("u-divider")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_u_fold, {
      unfold: "",
      line: "1",
      style: {"width":"50px"}
    }, {
      default: _withCtx(() => [
        _createTextVNode("hello world!")
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_u_fold, { line: "1" }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_u_fold, {
        unfold: "",
        line: "1"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_u_divider),
    _createVNode(_component_u_divider, null, {
      default: _withCtx(() => [
        _createTextVNode("我是分割线")
      ]),
      _: 1
    }),
    _createVNode(_component_u_divider, { "border-style": "dashed" }, {
      default: _withCtx(() => [
        _createTextVNode("我是虚线")
      ]),
      _: 1
    }),
    _hoisted_4,
    _createVNode(_component_u_divider, {
      vertical: "",
      "border-style": "dashed"
    }),
    _hoisted_5,
    _createVNode(_component_u_divider, { position: "left" }, {
      default: _withCtx(() => [
        _createTextVNode("我是左分割线")
      ]),
      _: 1
    }),
    _createVNode(_component_u_divider, { position: "right" }, {
      default: _withCtx(() => [
        _createTextVNode("我是右分割线")
      ]),
      _: 1
    }),
    _createVNode(_component_el_input)
  ], 64))
}
}

})